import { wixServerData } from '@wix/package-picker-shared';
export const useLocalization = () => {
  const {
    locale,
    geo
  } = wixServerData.get();
  return {
    shouldShowJapaneseExperience: locale === 'ja' && geo === 'JP',
    shouldShowFrenchExperience: locale === 'fr' && geo === 'FR'
  };
};
//# sourceMappingURL=useLocalization.js.map